// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"cbce2b6f","600":"c51212f7","786":"55002434","934":"d6aa4ff3"}[chunkId] + ".chunk.js";
};